import { IForm } from '@/components/types'

export const searchFormConfig: IForm = {
  formItems: [
    {
      field: 'stockTag',
      type: 'input',
      label: '概念名称',
      placeholder: '请输入概念名称'
    }
  ]
}
